import { Stack, Text } from "@mantine/core";
import { ResponsiveSunburst } from "@nivo/sunburst";
import "./styles.scss";

interface Props {
  title: JSX.Element,
  data?: any[],
  colors?: any,
  enableArcLabels?: boolean,
  arcLabel: any,
  valueFormat?: string,
  CenteredMetric?: any,
  toggler?: JSX.Element
}

function WidgetNivoSunburst(props: Props) {
  const {
    title,
    data,
    colors,
    enableArcLabels,
    arcLabel,
    valueFormat,
    CenteredMetric,
    toggler
  } = props;

  function renderGraph() {
    if (data) {
      return (
        <ResponsiveSunburst
          data={data}
          margin={{ top: 30, right: 30, bottom: 30, left: 30 }}
          colors={colors}
          childColor={{
            from: 'color',
            modifiers: [
              [
                'brighter',
                0.3
              ]
            ]
          }}
          enableArcLabels={enableArcLabels}
          arcLabel={arcLabel}
          arcLabelsSkipAngle={10}
          valueFormat={valueFormat}
          layers={["arcs", "arcLabels", CenteredMetric]}
        />
      )
    } else {
      return (
        <Stack align="center">
          <Text>No Data Found</Text>
        </Stack>
      )
    }
  }

  return (
    <div className="widget-nivo-base">
      <div className="header">
        {title}
        {toggler}
      </div>
      <div className="widget-chart-container">
        {renderGraph()}
      </div>
    </div>
  )
}

export default WidgetNivoSunburst;
